import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import {Redirect} from 'react-router-dom';
import {endCopyPrizeAction, submitCopyPrizeAction} from './actions';
import copyPrizeFormConfig from 'components/prizes/copyPrizeFormConfig';
import CopyPrizeModal from 'components/prizes/CopyPrizeModal';
import {formDataManager} from 'hoc/formDataManager';

const mapStateToProps = state => {
  const sourcePrize = state.resources.resources[state.copyPrize.copyPrizeId];
  const data = sourcePrize ? {
    title: `${sourcePrize.title}-copy`,
    lang: sourcePrize.lang
  } : null;

  const modalOpen = state.copyPrize.copyingPrize;
  const creationError = state.copyPrize.error;

  return {
    data,
    modalOpen,
    creationError,
    onlySaveUnchanged: false
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onSaveData: data => submitCopyPrizeAction(data.title, data.lang),
  handleClose: endCopyPrizeAction
}, dispatch);

const CopyPrizeModalContainerConnected = connect(mapStateToProps, mapDispatchToProps);

const CopyPrizeModalLifecycle = lifecycle({
  componentWillUnmount() {
    this.props.handleClose();
  }
});

const CopyPrizeFormDataManager = formDataManager({
  title: '',
  lang: ''
}, copyPrizeFormConfig);

const CopyPrizeModalContainer = compose(
  CopyPrizeModalContainerConnected,
  CopyPrizeModalLifecycle,
  CopyPrizeFormDataManager
)(CopyPrizeModal);

const CopyPrizeRedirect = props => (
  <div>{props.createdPrizeId && <Redirect to={`/prize/${props.createdPrizeId}/edit?openSection=editPrizeSection`} />}</div>
);

const CopyPrizeRedirectContainer = connect(state => ({
  createdPrizeId: state.copyPrize.createdPrizeId
}), null)(CopyPrizeRedirect);

const CopyPrizeModalContainerFragment = () => (
  <Fragment>
    <CopyPrizeModalContainer />
    <CopyPrizeRedirectContainer />
  </Fragment>
);

export default CopyPrizeModalContainerFragment;



// WEBPACK FOOTER //
// ./public/pages/PrizeCopy/CopyPrizeModalContainer.jsx